import {styled, Box} from '@mui/material';

import {LargeExpressIcon} from 'assets/icons/largeExpressIcon';
import {LargeThaiExpressIcon} from 'assets/icons/largeThaiExpressIcon';
import {OfferToCarryProduct} from 'assets/icons/offerToCarryProduct';
import {PreOrderIcon} from 'assets/icons/preOrder';
import {TruckLeo1P} from 'assets/icons/truckLeo1P';
import {TruckLeo3P} from 'assets/icons/TruckLeo3P';
import {TruckSameDay} from 'assets/icons/truckSameDay';

export const FontWeightBold = styled('span')(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold
}));

export const FontWeightMedium = styled('span')(({theme}) => ({
  fontWeight: theme.typography.h1.fontWeight
}));

export const FontWeightLight = styled('span')(({theme}) => ({
  fontWeight: theme.typography.subtitle2.fontWeight
}));

export const FontSizeExtraLarge = styled('span')(({theme}) => ({
  fontSize: theme.spacing(2.5)
}));

export const FontSizeLarge = styled('span')(({theme}) => ({
  fontSize: theme.spacing(2)
}));

export const FontSizeMedium = styled('span')(({theme}) => ({
  fontSize: theme.spacing(1.75)
}));

export const FontSizeSmall = styled('span')(({theme}) => ({
  fontSize: theme.spacing(1.5)
}));

export const FontSizeExtraSmall = styled('span')(({theme}) => ({
  fontSize: theme.spacing(1.25)
}));

export const StyledMargin = styled(Box)(({theme}) => ({
  '&.ml2': {
    marginLeft: theme.spacing(0.25)
  },
  '&.ml3': {
    marginLeft: theme.spacing(0.375)
  },
  '&.ml4': {
    marginLeft: theme.spacing(0.5)
  },
  '&.ml8': {
    marginLeft: theme.spacing(1)
  },
  '&.mt4': {
    marginTop: theme.spacing(0.5)
  },
  '&.mt8': {
    marginTop: theme.spacing(1)
  },
  '&.mt12': {
    marginTop: theme.spacing(1.5)
  },
  '&.mt16': {
    marginTop: theme.spacing(2)
  }
}));

export const StyledPadding = styled(Box)(({theme}) => ({
  '&.pl24': {
    paddingLeft: theme.spacing(3)
  }
}));

export const StyledDisplayFlex = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}));

export const StyledBadgeContainer = styled(Box)(({theme}) => ({
  display: 'inline-flex',
  border: `solid ${theme.spacing(0.0625)} ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(1)
}));

export const StyledBadgeContent = styled(Box)(({theme}) => ({
  padding: theme.spacing(0.5, 1)
}));

export const StyledEllipsisText = styled('span')(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: '1'
}));

export const StyledPopupBadgeContent = styled(Box)(({theme}) => ({
  padding: theme.spacing(0.5, 1)
}));

export const StyledOrangeText = styled('span')(({theme}) => ({
  color: theme.palette.common.mds_global_color_orange_10
}));

export const StyledGradientText = styled('span')(({theme}) => ({
  background: `linear-gradient(90deg, ${theme.palette.common.mds_global_color_red_10} 6.62%, ${theme.palette.common.mds_global_color_orange_90} 100.69%)`,
  backgroundClip: 'text',
  WebkitbackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
}));

export const StyledBlueText = styled('span')(({theme}) => ({
  color: theme.palette.common.mds_global_color_blue_30
}));

export const StyledPurpleText = styled('span')(({theme}) => ({
  color: theme.palette.common.mds_global_color_purple_1
}));

export const StyledRedText = styled('span')(({theme}) => ({
  color: theme.palette.common.mds_global_color_red_25
}));

export const StyledGrayText = styled('span')(({theme}) => ({
  color: theme.palette.grey[400]
}));

export const StyledUnorderedList = styled('ul')(({theme}) => ({
  padding: theme.spacing(0)
}));

export const StyledCustomTags = {
  fontWeightBold: <FontWeightBold />,
  fontWeightMedium: <FontWeightMedium />,
  fontWeightLight: <FontWeightLight />,
  fontSizeExtraLarge: <FontSizeExtraLarge />,
  fontSizeLarge: <FontSizeLarge />,
  fontSizeMedium: <FontSizeMedium />,
  fontSizeSmall: <FontSizeSmall />,
  fontSizeExtraSmall: <FontSizeExtraSmall />,
  ml2: <StyledMargin className="ml2" />,
  ml3: <StyledMargin className="ml3" />,
  ml4: <StyledMargin className="ml4" />,
  ml8: <StyledMargin className="ml8" />,
  mt4: <StyledMargin className="mt4" />,
  mt8: <StyledMargin className="mt8" />,
  mt12: <StyledMargin className="mt12" />,
  mt16: <StyledMargin className="mt16" />,
  pl24: <StyledPadding className="pl24" />,
  displayFlex: <StyledDisplayFlex />,
  badgeContainer: <StyledBadgeContainer />,
  badgeContent: <StyledBadgeContent />,
  ellipsisText: <StyledEllipsisText />,
  popupBadgeContent: <StyledPopupBadgeContent />,
  orangeText: <StyledOrangeText />,
  gradientText: <StyledGradientText />,
  blueText: <StyledBlueText />,
  redText: <StyledRedText />,
  purpleText: <StyledPurpleText />,
  grayText: <StyledGrayText />,
  offerToCarryProduct: <OfferToCarryProduct />,
  b: <b />,
  br: <br />,
  ul: <StyledUnorderedList />,
  li: <li />,
  sameDayTruckIcon: <TruckSameDay width={28} height={28} />,
  nextDayTruckIcon: <TruckLeo1P width={28} height={28} />,
  truck3PIcon: <TruckLeo3P width={28} height={28} />,
  preOrderIcon: <PreOrderIcon width={16} height={16} />,
  sameDayTruckIconSmall: <TruckSameDay width={21} height={14} />,
  nextDayTruckIconSmall: <TruckLeo1P width={21} height={14} />,
  truck3PIconSmall: <TruckLeo3P width={21} height={14} />,
  preOrderIconSmall: <PreOrderIcon width={14} height={14} />,
  expressDeliveryIconSmall: <LargeExpressIcon width={42} height={20} />,
  expressDeliveryThaiIconSmall: <LargeThaiExpressIcon width={42} height={20} />
};
